var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-select",
    {
      attrs: {
        disabled: _vm.disabled,
        options: _vm.getSource(),
        filterable: _vm.searchable ? false : true,
        label: _vm.labelKey,
        multiple: _vm.multiple,
        reduce: _vm.getReduceFunc()
      },
      on: {
        search: _vm.searchValue,
        input: function($event) {
          return _vm.selectValue($event)
        }
      },
      scopedSlots: _vm._u(
        [
          _vm.customOption
            ? {
                key: "selected-option",
                fn: function(option) {
                  return [
                    _vm.isCustomer
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                option.Description1 +
                                " - " +
                                (option.StatusId === 2
                                  ? _vm.$t("insert.passive")
                                  : _vm.$t("insert.active"))
                            )
                          )
                        ])
                      : _vm.isVehicle
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                (option.VehiclePlateNumber
                                  ? option.VehiclePlateNumber
                                  : option.Description1) +
                                " - " +
                                (option.StatusId === 2
                                  ? _vm.$t("insert.passive")
                                  : _vm.$t("insert.active"))
                            )
                          )
                        ])
                      : _vm.isEmployee
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                (option.Name && option.Surname
                                  ? option.Name + " " + option.Surname
                                  : option.Description1)
                            )
                          )
                        ])
                      : _vm.isPrefix
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Prefix +
                                " - " +
                                option.Year +
                                " " +
                                (option.EInvoiceType
                                  ? option.EInvoiceType.Label
                                  : "")
                            )
                          )
                        ])
                      : _vm.isCustomSlot
                      ? _c(
                          "div",
                          [_vm._t("selected-option", null, { option: option })],
                          2
                        )
                      : option.Code
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                (option.Description1
                                  ? " - " + option.Description1
                                  : "")
                            )
                          )
                        ])
                      : _c("span", [_vm._v(_vm._s(option.Description1))])
                  ]
                }
              }
            : null,
          _vm.customOption
            ? {
                key: "option",
                fn: function(option) {
                  return [
                    _vm.isCustomer
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                option.Description1 +
                                " - " +
                                (option.StatusId === 2
                                  ? _vm.$t("insert.passive")
                                  : _vm.$t("insert.active"))
                            )
                          )
                        ])
                      : _vm.isVehicle
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                option.VehiclePlateNumber +
                                " - " +
                                (option.StatusId === 2
                                  ? _vm.$t("insert.passive")
                                  : _vm.$t("insert.active"))
                            )
                          )
                        ])
                      : _vm.isEmployee
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                option.Name +
                                " " +
                                option.Surname
                            )
                          )
                        ])
                      : _vm.isPrefix
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Prefix +
                                " - " +
                                option.Year +
                                " " +
                                (option.EInvoiceType
                                  ? option.EInvoiceType.Label
                                  : "")
                            )
                          )
                        ])
                      : _vm.isCustomSlot
                      ? _c(
                          "div",
                          [_vm._t("option", null, { option: option })],
                          2
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              option.Code +
                                " - " +
                                option.Description1 +
                                " - " +
                                (option.StatusId === 2
                                  ? _vm.$t("insert.passive")
                                  : _vm.$t("insert.active"))
                            )
                          )
                        ])
                  ]
                }
              }
            : null
        ],
        null,
        true
      ),
      model: {
        value: _vm.selectedValue,
        callback: function($$v) {
          _vm.selectedValue = $$v
        },
        expression: "selectedValue"
      }
    },
    [
      _vm.searchable
        ? _c("template", { slot: "no-options" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("insert.min3")) + "\n    ")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23237254", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23237254","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextDropdown.vue
// module id = null
// module chunks = 